import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'
import { InfoCircleLine } from '@factorialco/f0-react/icons/app'
import { ContractVersionsPageEmployeeContractActivityPeriodFragment } from 'generated/resources/graphql'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

interface Props {
  contractActivity?: ContractVersionsPageEmployeeContractActivityPeriodFragment | undefined
}

const DaysActive = ({ contractActivity }: Props) => {
  const daysCount = contractActivity?.currentYearActiveDaysCount
  const today = moment()

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 3 }} gap="s2">
      <Box gap="s8">
        <Box flexDirection="row" alignItems="center" gap="s4" height="s24">
          <Text size="200" weight="normal" color="grey800">
            {i18n.t('contract_versions.fix_discontinuous.days_active.current_year')}
          </Text>
          <Tooltip description={i18n.t('contract_versions.fix_discontinuous.days_active.tooltip')}>
            <F0Icon icon={InfoCircleLine} />
          </Tooltip>
        </Box>
        {daysCount ? (
          <Text size="300" weight="medium" color="grey1000">
            {i18n.tp('contract_versions.fix_discontinuous.days_active.days_active', {
              count: daysCount,
            })}
          </Text>
        ) : (
          <Text size="300" weight="medium" color="grey600">
            {i18n.t('contract_versions.fix_discontinuous.not_informed')}
          </Text>
        )}
      </Box>

      <Text size="200" weight="normal" color="grey800">
        {i18n.t('contract_versions.fix_discontinuous.days_active.since', {
          date: today.year(),
        })}
      </Text>
    </Box>
  )
}

export default DaysActive
